import { Flex } from '@chakra-ui/react'

import { CustomSelect } from '../CustomSelect'

type Values = '1' | '2'

export default function SemesterInput({
  value,
  onChange
}: {
  value: Values | ''
  onChange: (data: Values) => void
}) {
  return (
    <Flex columnGap={'2'} w={'full'}>
      <CustomSelect
        options={[
          {
            label: 'Primeiro semestre',
            value: '1'
          },
          {
            label: 'Segundo semestre',
            value: '2'
          }
        ]}
        value={value}
        onChange={(v) => onChange(v as Values)}
      />
    </Flex>
  )
}
